module.exports = __webpack_public_path__ + "img/167.45d57998.jpg";